import type { BoundingBox, Point } from "../types.ts";
import type { HeadlessConnector } from "./types.ts";

export const boundsFromElement = (rect?: DOMRect, offsetRect?: DOMRect): BoundingBox => {
  if (!rect) {
    return { x: 0, y: 0, width: 0, height: 0 };
  }

  return {
    x: rect.left - (offsetRect ? offsetRect.left : 0),
    y: rect.top - (offsetRect ? offsetRect.top : 0),
    width: rect.right - rect.left,
    height: rect.bottom - rect.top,
  };
};

export const translateBounds = (bounds: BoundingBox, { x, y }: Point): BoundingBox => ({ ...bounds, x, y });

export const getConnectorId = ({ from, to, bidirectional }: HeadlessConnector) =>
  `${from}:${to}:${bidirectional ? "true" : "false"}`;

export const getConnectorFromId = (id: string): HeadlessConnector => {
  const [fromId, toId, bidirectional] = id.split(":");

  return {
    from: Number(fromId),
    to: Number(toId),
    bidirectional: bidirectional === "true",
  };
};
